import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthenticationProvider } from "../providers/authentication/authentication";
import { CoreProvider } from "../providers/core/core.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { ErrorLoggerService } from "src/services/logging/error-logger.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isErrorAlertShown = false;
  constructor(
    private authenticationService: AuthenticationProvider,
    private translate: TranslateService,
    private coreService: CoreProvider,
    private router: Router,
    private errorLogger: ErrorLoggerService
  ) {}
  /***
   * description: http intercepter to handle API errors
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
       
        this.coreService.hideLoader();
        switch (err.status) {
        case 401:
          // Unauthorized: logout and reload
          this.authenticationService.logout();
          window.location.reload();
          break;

        case 500:
          // only show if no alert is currently visible
            if (!this.isErrorAlertShown) {
              this.isErrorAlertShown = true;
              this.coreService.presentAlert(this.translate.instant("Internal_ERR"))
                .then(() => {
                  this.isErrorAlertShown = false; // reset after user clicks OK
                });
            }
          break;

        case 400:
          // Bad request – handle if needed
          break;

        case 200:
        case 404:
          // Ignore or handle gracefully depending on app logic
          break;

        default:
          this.coreService.presentAlert(this.translate.instant("GENERIC_ERR_MSG"));
         
          break;
      }
        this.errorLogger.log({
          ErrorType: 'HttpError',
          Status: err.status,
          ErrorMessage: err.message,
          Url: request.url,
          Method: request.method,
          Route: this.router.url,
          RawResponse: err.error,
          DeviceId: localStorage.getItem('deviceId') || '',  
          UserId: this.coreService.getUserId() || ''
        });
        return throwError(err);
      })
    );
  }
}
